import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { setRevalidatedPad } from '../utils/setRevalidatedPad';
import { handleUnselectedProduct } from '../utils/updateMedicationPadItems';

export const removeMedicationPadItemById: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (medicationPadItemId: string) => void
> = (set, get) => (medicationPadItemId) => {
  const { prescriptionAssistant, updatePrescriptionHistoryItemsToReissue, updatePrescriptionHistoryItemsToCancel } =
    get();
  const { prescriptionPad, prescriptionPadRules } = prescriptionAssistant;

  const itemToRemove = prescriptionPad.medicationPadItems.find(
    (item) => item.medicationPadItemId === medicationPadItemId,
  );

  if (itemToRemove?.medicationPadItem) {
    const { updatedCancelledItems, updatedReissuedItems } = handleUnselectedProduct(
      itemToRemove.medicationPadItem?.productId,
      prescriptionAssistant.prescriptionHistory.previousItems,
      prescriptionAssistant.prescriptionHistory.itemsToReissue,
      prescriptionAssistant.prescriptionHistory.itemsToCancel,
    );
    updatePrescriptionHistoryItemsToCancel(updatedCancelledItems);
    updatePrescriptionHistoryItemsToReissue(updatedReissuedItems);
  }
  // The item taken off the pad changes its formulation's limit in force, written into each remaining sibling's dosage
  setRevalidatedPad(
    set,
    {
      ...prescriptionPad,
      medicationPadItems: prescriptionPad.medicationPadItems.filter(
        (item) => item.medicationPadItemId !== medicationPadItemId,
      ),
    },
    prescriptionPadRules,
    'prescriptionPad/removeMedicationPadItemById',
  );
};
